import { render, staticRenderFns } from "./147.vue?vue&type=template&id=6274f22b&scoped=true&"
var script = {}
import style0 from "./147.vue?vue&type=style&index=0&id=6274f22b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6274f22b",
  null
  
)

export default component.exports